/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);

    if (this.closest('.blog-post-content--custom-article')) {
      this.#formatCustomArticleSteps();
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Wraps h5 (number) + h6 (heading) step pairs into Figma-style article step blocks
   */
  #formatCustomArticleSteps() {
    /** @type {{ numberEl: HTMLHeadingElement; headingEl: HTMLHeadingElement }[]} */
    const steps = [];

    this.querySelectorAll('h5').forEach((numberEl) => {
      if (!(numberEl instanceof HTMLHeadingElement)) return;
      if (numberEl.closest('.article-step')) return;

      const headingEl = numberEl.nextElementSibling;
      if (!(headingEl instanceof HTMLHeadingElement) || headingEl.tagName !== 'H6') return;

      steps.push({ numberEl, headingEl });
    });

    for (let index = steps.length - 1; index >= 0; index -= 1) {
      const { numberEl, headingEl } = steps[index];
      const parent = numberEl.parentNode;
      if (!parent) continue;

      const step = document.createElement('div');
      step.classList.add('article-step');

      const content = document.createElement('div');
      content.classList.add('article-step__content');

      parent.insertBefore(step, numberEl);

      numberEl.classList.add('article-step__number');

      let sibling = headingEl.nextElementSibling;
      /** @type {Element[]} */
      const bodyNodes = [];
      while (sibling) {
        if (sibling.tagName === 'H5' || sibling.classList.contains('article-step')) break;

        const next = sibling.nextElementSibling;
        bodyNodes.push(sibling);
        sibling = next;
      }

      content.appendChild(headingEl);
      bodyNodes.forEach((node) => {
        content.appendChild(node);
      });

      step.appendChild(numberEl);
      step.appendChild(content);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
